<template>
  <!--点击使用制作工具按钮弹窗-->
  <a-modal
    v-model="openAppVisible"
    title="打开精彩纵横投标文件制作工具"
    :closable="false"
    ok-text="打开"
    cancel-text="取消"
    :mask-closable="false"
    @ok="handleOpenApp"
  >
    <p>为了数据安全，请使用桌面端投标文件制作工具进行文件的制作。</p>
    <p>
      若未安装投标文件制作工具，请
      <a-button type="link" style="padding: 0" @click="downloadApp">
        点击此处
      </a-button>
      下载。
    </p>
    <div v-if="!inVip" class="bid-dog-box">
      <div class="text">
        对电子投标流程不熟悉？投标文件制作工具操作不熟练？推荐资深顾问一对一服务，项目全程代办，提升投标效率！
      </div>
      <div class="btn-box">
        <div class="btn btn1" @click="goPage(1)">了解详情</div>
        <div class="btn btn2" @click="goPage(2)">立即开通</div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { downloadAppTool } from '@/utils/utils'
import { mapGetters, mapState } from 'vuex'
import { toVipBuy } from '@/utils/platform'
import { getAccessTokenApi } from '@/api/user'

export default {
  name: 'BidToolDownload',

  model: {
    prop: 'visible',
    event: 'change'
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    // 协议目标路由
    appRouterName: {
      type: String,
      default: ''
    },

    // 协议传参
    params: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters('user', ['inVip']),
    ...mapState('user', ['employeeId', 'mobile']),
    ...mapState('company', ['companyId']),

    openAppVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  },

  methods: {
    downloadApp() {
      downloadAppTool()
    },

    async handleOpenApp() {
      try {
        const { data } = await getAccessTokenApi()
        const params = {
          token: data,
          companyId: this.companyId,
          employeeId: this.employeeId,
          routerName: this.appRouterName,
          ...this.params
        }
        const APP_URL =
          'jczh-bid-tool:platform?' +
          Object.keys(params)
            .map(key => `${key}=${params[key]}`)
            .join('&')
        window.open(APP_URL, '_self')
        this.openAppVisible = false
      } catch (err) {
        console.error('打开本地app失败', err)
        if (err?.message) this.$message.error(err.message)
      }
    },

    // 跳转至相应页面
    goPage(type) {
      if (type === 1) {
        const url = process.env.VUE_APP_BIDDOG_URL + `/treasureChest/consultant`
        window.open(url, '_blank')
      } else {
        toVipBuy()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bid-dog-box {
  background: url('~@/assets/images/supplier/bid-dog/img1.png') no-repeat;
  background-size: cover;
  font-size: 14px;
  box-sizing: border-box;
  padding: 12px 16px;
  color: $white-color;
  display: flex;
  border-radius: 4px;
  line-height: 22px;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  height: 100%;
  .btn-box {
    display: flex;
    .btn {
      width: 72px;
      height: 24px;
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: $member-second-color;
      cursor: pointer;
      border-radius: 4px;
    }
    .btn1 {
      border: 1px solid $white-color;
      color: $white-color;
    }
    .btn2 {
      margin-left: 10px;
      color: $member-second-color;
      background: $member-sixth-color;
    }
  }
}
</style>
